import { useState, useEffect, useRef } from "react";
import { createModel } from "hox";
import { message } from "antd";
import useGlobalModel, { transPgToPagination } from "@/model/globalModel";
import { useLockFn } from "ahooks";
import { enquiryService } from "../../../enquiryService";
import { TablePaginationConfig } from "antd/lib/table";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "@/utils/constants";
import { ISupplierOfferSearch, ISupplierOfferDetails, ISupplierPriceDialog, ISupplierMaterialDetails, IEnquiryMaterialDetail } from "../../../enquiryTypes";
import { formatNum, formatInt } from "@/utils/utils";
import { useEnquiryDetailModel } from "../enquiryDetailModel";
import { globalPrompt } from "@/components/message";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { convertRes2Blob } from "@/utils/exportFile";
import useNavModel from "@/model/navModel";
import { useOfferDetailModel } from "@/views/inquires/offer/view/details/offerDetailModel";
import moment from "moment";

export const useSupplierOfferModel = createModel(function () {
    const { user: { shopCode, shopName }, setLoadingInfo } = useGlobalModel(({ user }) => [user]);
    const { editFormVal, getEnquiryDetailOne } = useEnquiryDetailModel(({ editFormVal }) => [editFormVal])
    const { updateFormVal: offerUpdateFormVal } = useOfferDetailModel(() => []);

    //询价单code
    const [enquiryCode, setEnquiryCode] = useState<string>("");

    /**列表 */
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [dataSource, setDataSource] = useState<ISupplierOfferDetails[]>([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const { replaceNav } = useNavModel(() => []);

    const loadData = async (page: ISupplierOfferSearch = initPgCfg) => {
        const searchParams = {
            code: editFormVal.code ?? enquiryCode,
            shopCode,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await enquiryService.pageOffer(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }

    //作废
    const dispbleOffer = async (id?: string) => {
        let { retData } = await enquiryService.disableOffer(id ?? selectedRowKeys[0]);
        loadData();
        setSelectedRowKeys([])
        globalPrompt("message", { text: "操作成功", type: "success" })
    }
    /**详情 */

    //供应商报价信息弹框
    const [supplierDialog, setSupplierDialog] = useState<ISupplierPriceDialog>({
        visible: false,
        mode: 'add'
    });
    const [formVal, setFormVal] = useState<ISupplierOfferDetails>({ id: "", shopName });
    const [materialList, setMaterialList] = useState<ISupplierMaterialDetails[]>([]);
    const [selectedMaterialRowKeys, setSelectedMaterialRowKeys] = useState<string[]>([]);

    //商品子表添加
    const insertMaterial = (arr: IEnquiryMaterialDetail[]) => {
        setMaterialList(origin => {
            let newArr: ISupplierMaterialDetails[] = [...origin];
            arr.forEach(material => {
                //选中的是否存在列表
                let isExist = origin.find(item => item.materialCode == material.materialCode);
                if (!isExist) {
                    let num = +formatInt(material.num);
                    let price = formatNum(material.price);
                    newArr.push({
                        key: material.id,
                        "inquiryOrderDetailsId": material.id,         //    // "询价单详情id",
                        "materialCode": material.materialCode,         //    // "物料编号",
                        "replaceCode": material.replaceCode,        //    // "替换号",
                        "materialName": material.materialName,       //    // "物料名称",
                        "materialEname": material.materialEname,        //    // "物料名称",
                        "typeCode": material.typeCode,       //    // "物料类型",
                        "typeName": material.typeName,       //    // "物料类型名称",
                        "unitCode": material.unitCode, // 
                        "unitName": material.unitName, // "单位",
                        "customsCode": material.customsCode, // "单位",
                        "num": num,      //|    // 5,
                        "price": price,      //|    // 99,
                        "amount": formatNum(num * +price),       //|    // 99,
                        "model": material.model,         //    // "规格",
                        "note": ""         //    // "备注"
                    })
                }
            });
            return newArr;
        });
        setSupplierMaterialDialog(false);
    }

    //重置缓存
    const resetCache = () => {
        setFormVal({ id: "", shopName });
        setMaterialList([]);
        setSelectedRowKeys([]);
    }

    //获取供应商报价one
    const getSupplierMaterialOne = async (id?: string) => {
        let { retData } = await enquiryService.oneOffer(id ?? selectedRowKeys[0]);
        let { details, ...formVal } = retData;
        if (retData) {
            setFormVal({
                ...formVal,
                createTime: formVal.createTime ? moment(formVal.createTime) : null
            });
            setMaterialList(details?.map(item => ({ ...item, key: item.id ?? "" })) ?? []);
        }
        return retData;
    }


    //报价单新增 | 编辑
    const insertOrUpdateSupplierOffer = useLockFn(async (mode: string, val: ISupplierOfferDetails) => {
        let data = {
            ...val,
            relevanceOrderId: editFormVal.relevanceOrderId,
            inquiryOrderCode: editFormVal.code,
            shopCode,
            amountTotal: materialList.reduce((con, next) => { con = con + +(next.amount ?? 0); return con }, 0),
            details: materialList.map(item => {
                let { createTime, createUser, deleteFlag, updateTime, updateUser, key, giftsNum, ...param } = item;
                return param;
            })
        };
        //新增
        if (mode === "edit") {
            let { retData } = await enquiryService.updateOffer({ ...data, id: formVal.id, code: formVal.code });
            loadData()
            message.success("编辑成功")
            return retData;
        } else {
            let { retData } = await enquiryService.insertOffer(data);
            loadData()
            message.success("新增成功")
            return retData;
        }
    })

    //出口报价
    const transferOffer = async () => {
        if (editFormVal.status !== DictCodeEnmu.INQUIRY_PEND) {
            message.warning("此状态的询价单不可以再转接出口报价单");
            return;
        }

        if (!selectedRowKeys.length) {
            return message.warning("请选择数据进行编辑");
        };

        if (dataSource.find(item => item.code === selectedRowKeys[0])?.status === "inquiry.cancel") {
            return message.warning("已作废的单据不可操作");
        }

        let { retData } = await enquiryService.transferOffer({ shopCode, code: selectedRowKeys.join() });
        await getEnquiryDetailOne(editFormVal.id)
        message.success("出口报价成功,自动跳转报价单详情");
        if (retData) {
            //转报价单页面
            offerUpdateFormVal("edit", null)
            replaceNav("2-1-1", "2-2-2", { id: retData as string, mode: "edit" });
        }
    }

    //明细导出
    const exportEnquiry = async () => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            let result = await enquiryService.offerExport(formVal.code ?? "", shopCode);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    }

    //报价单明细下载模板
    const offerDownloadTpl = async () => {
        let result = await enquiryService.offerGoodsDownloadTpl(editFormVal.code, shopCode);
        // let result = await enquiryService.offerDownloadTpl();
        convertRes2Blob(result);
    }

    //获取上传url  (询价单code)
    const getUploadUrl = () => {
        return `/gtm/supplierOffer/detail/import/${editFormVal.code ?? enquiryCode}/${shopCode}`
    }

    /**商品弹框 */
    //供应商报价-添加商品信息弹框
    const [supplierMaterialDialog, setSupplierMaterialDialog] = useState<boolean>(false);
    return {
        /***field***/
        editFormVal,
        enquiryCode, setEnquiryCode,
        dataSource, pgCfg,
        supplierDialog, setSupplierDialog,
        selectedRowKeys, setSelectedRowKeys,
        supplierMaterialDialog, setSupplierMaterialDialog,
        materialList, setMaterialList,
        formVal, setFormVal,
        selectedMaterialRowKeys, setSelectedMaterialRowKeys,
        /***method***/
        loadData,
        insertOrUpdateSupplierOffer,
        getSupplierMaterialOne,
        resetCache,
        insertMaterial,
        dispbleOffer,
        transferOffer,
        exportEnquiry,
        offerDownloadTpl,
        getUploadUrl
    }
});